import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { schoolDetailService } from "../services/school";

export const useSchool = () => {
  const hasToken = !!Cookies.get("accessToken");

  return useQuery({
    queryKey: ["school"],
    queryFn: () => schoolDetailService.getSchoolDetails(),
    staleTime: 5 * 60 * 1000,
    enabled: hasToken,
    retry: false,
  });
};

export const useGetSchoolEducationLevels = (enabled: boolean) => {
  return useQuery({
    queryKey: ["school-education-levels"],
    queryFn: () => schoolDetailService.getSchoolEducationLevels(),
    enabled: enabled,
  });
};

export const useGetIslandList = (enabled: boolean) => {
  return useQuery({
    queryKey: ["school-island-list"],
    queryFn: () => schoolDetailService.getIslandList(),
    enabled: enabled,
  });
};
